import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/gossip';

export default function Faq() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '常见问题', item: '/faq' },
        ],
      },
    ],
    [],
  );

  useSeo({
    title: '常见问题 - 福利吃瓜抽奖打卡投票规则说明 - 瓜田福利社',
    description:
      '解答福利吃瓜转发抽奖的参与条件、评论区打卡的刷新时间、粉丝投票的次数限制以及开奖结果的公布方式，参与前先看清规则。',
    keywords: '福利吃瓜抽奖规则,福利吃瓜打卡时间,粉丝投票规则,常见问题',
    path: '/faq',
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="pt-16 md:pt-[68px]">
        <section className="w-full px-4 md:px-8 pt-8 md:pt-12 pb-10 bg-background-100 border-b border-background-200">
          <Breadcrumbs items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />
          <div className="mt-5 max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs mb-4">
              <i className="ri-question-line"></i>
              帮助中心
            </span>
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
              常见问题
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于福利吃瓜转发、抽奖、评论区互动、打卡、粉丝投票的规则说明，都整理在这里。如果还有疑问，欢迎直接给我们留言。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="max-w-4xl">
            <FaqAccordion items={faqs} />

            <div className="mt-10 rounded-lg bg-background-100 border border-background-200 p-6 md:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
                  没有找到你要的答案？
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  可以把具体问题发给我们，通常会在一天内回复。
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <Link
                  to="/about#contact"
                  className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors text-center"
                >
                  去留言
                </Link>
                <Link
                  to="/activities"
                  className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:border-primary-300 transition-colors text-center"
                >
                  查看互动玩法
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}